module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "name": "error-modal",
      "classes": ['v--modal', 'error-modal', _vm.hasBugs && 'has-bugs'],
      "pivot-y": 0.2,
      "width": 400,
      "height": 300
    },
    on: {
      "before-open": _vm.beforeOpen,
      "before-close": _vm.beforeClose
    }
  }, [_c('div', {
    staticClass: "error-modal-content"
  }, [_c('div', {
    staticClass: "bugs-label"
  }, [_vm._v("bugs: " + _vm._s(_vm.bugCount))]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.createBug
    }
  }, [_vm._v("Create a bug")]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.fixBug
    }
  }, [_vm._v("Fix a bug")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n      You will be able to close the window only if you have fixed all the bugs :)\n    ")]), _vm._v(" "), _c('sub', {
    style: ({
      opacity: _vm.hasBugs ? 1 : 0
    })
  }, [_vm._v("\n      " + _vm._s(_vm.bugCount) + " bugs to fix\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8610f30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/DemoErrorModal.vue
// module id = 37
// module chunks = 0